export default __webpack_public_path__ + "static/vid-ba51556961a482beae71977d8f3cbdb0.mp4";